<template>
  <div class="md-layout">
    <div v-if="$route.params.id" id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{formConfig.headerIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color content-wrap">{{recordData? recordData.given_name + ' ' + recordData.family_name : ''}}</h1>
      </div>
    </div>

    <template
      v-if="$route.params.id">
      <md-tabs md-sync-route class="topNavTabs">

        <md-tab id="tab-person" md-label="Person" :to="recordPath" exact>
          <ConfigForm :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :recordData="recordData" :headerColor="headerColor"></ConfigForm>
        </md-tab>

        <md-tab id="tab-companies" md-label="Companies" :to="recordPath + '/companies'">
          <ElasticList
            v-if="$route && $route.meta.tab === 'companies'"
            :list.sync="companysList"
            :filter="personCompanyPersonId"
            ref="companysListRef"
          ></ElasticList>
          <!--v-on:deleteRow="updateRecordData"-->

          <md-dialog :md-active.sync="companysList.showRelatedDialog">
            <md-dialog-title>{{relateCompanysList.pageTitle}}</md-dialog-title>
            <md-dialog-content>

              <ElasticList
                v-if="companysList.showRelatedDialog && recordData"
                :list.sync="relateCompanysList"
                :exclude="relateCompanyPersonFilter"
                :relateRecordInput="{personCompanyPersonId: $route.params.id, personCompanyCompanyId: null}"
                relateRecordInputField="personCompanyCompanyId"
              ></ElasticList>
              <!--v-on:relationshipAdded="updateRecordData"-->

            </md-dialog-content>
            <md-dialog-actions>
              <md-button class="md-theme-default" @click="companysList.showRelatedDialog = false">Close</md-button>
            </md-dialog-actions>
          </md-dialog>
        </md-tab>

        <md-tab id="tab-account" md-label="Accounts" :to="recordPath + '/accounts'">
          <ElasticList
            v-if="$route && $route.meta.tab === 'accounts'"
            :list.sync="accountsList"
            :filter="personAccountPersonId"
            ref="accountsListRef"
          ></ElasticList>
          <!--v-on:deleteRow="updateRecordData"-->

          <md-dialog :md-active.sync="accountsList.showRelatedDialog">
            <md-dialog-title>{{relateAccountsList.pageTitle}}</md-dialog-title>
            <md-dialog-content>

              <ElasticList
                v-if="recordData"
                :list.sync="relateAccountsList"
                :exclude="relateAccountPersonFilter"
                :relateRecordInput="{personAccountPersonId: $route.params.id, personAccountAccountId: null, role: null}"
                relateRecordInputField="personAccountAccountId"
                relateRecordInputRole="role"
              ></ElasticList>
              <!--v-on:relationshipAdded="updateRecordData"-->

            </md-dialog-content>
            <md-dialog-actions>
              <md-button class="md-theme-default" @click="accountsList.showRelatedDialog = false">Close</md-button>
            </md-dialog-actions>
          </md-dialog>
        </md-tab>

        <md-tab id="tab-person-cases" md-label="Cases" :to="recordPath + '/cases'">

          <ElasticList
            v-if="$route && $route.meta.tab === 'cases' && recordData"
            :list.sync="casesList"
            :filter="casePersonFilter"
          ></ElasticList>
          <!--<md-dialog :md-active.sync="casesList.showRelatedDialog">
            <md-dialog-title>{{relateCasesList.pageTitle}}</md-dialog-title>

            <md-dialog-content>
              <ElasticList
                v-if="casesList.showRelatedDialog && recordData"
                :list.sync="relateCasesList"
                :relateRecordInput="{casePersonId: $route.params.id}"
                relateRecordInputField="id"
              ></ElasticList>
            </md-dialog-content>

            <md-dialog-actions>
              <md-button class="md-theme-default" @click="casesList.showRelatedDialog = false">Close</md-button>
            </md-dialog-actions>
          </md-dialog>-->
        </md-tab>

      </md-tabs>
    </template>

    <div v-else class="md-layout-item md-small-size-100">
      <ConfigForm :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :recordData="recordData" :headerColor="headerColor"></ConfigForm>
    </div>

  </div>
</template>

<script>
  import _ from 'lodash';
  import Record from '@/mixins/Record';

  // Form validations
  import { required, numeric, minLength } from "vuelidate/lib/validators";
  
  export const personFields = {
    id: { label: "ID", type: "id", slot: 'basic' },
    given_name: { label: "First Name", type: "text", slot: 'basic' },
    middle_name: { label: "Middle Name", type: "text", slot: 'basic' },
    family_name: { label: "Last Name", type: "text", slot: 'basic' },
    email: { label: "Email", type: "text", slot: 'basic' },
    phone_mobile: { label: "Mobile", type: "text", slot: 'basic' },
    phone_number: { label: "Main Phone", type: "text", slot: 'basic' },
    phone_other: { label: "Other Phone", type: "text", slot: 'basic' },
    phone_home: { label: "Home Phone", type: "text", slot: 'basic' },
    fax_number: { label: "Fax", type: "text", slot: 'basic' },
    addressHome : {
      label: "Home Address",
      type: "json",
      slot: 'contact',
      fields: {
        street_address: { label: "Street Address", type: "text", slot: 'contact' },
        locality: { label: "City", type: "text", slot: 'contact' },
        region: { label: "State", type: "select", slot: 'contact', optionType: 'enum', options: []}, //State
        postal_code: { label: "Postal Code", type: "text", slot: 'contact' },
        country: {label: "Country", type: "select", slot: "contact", optionType: 'enum', options: []},
      }
    },
    addressOther  : {
      label: "Other Address",
      type: "json",
      slot: 'contact',
      fields: {
        street_address: { label: "Street Address", type: "text", slot: 'contact' },
        locality: { label: "City", type: "text", slot: 'contact' },
        region: { label: "State", type: "select", slot: 'contact', optionType: 'enum', options: []}, //State
        postal_code: { label: "Postal Code", type: "text", slot: 'contact' },
        country: {label: "Country", type: "select", slot: "contact", optionType: 'enum', options: []},
      }
    },
    ssn: { label: "SSN", type: "text", slot: 'additional' },
    dob: { label: "Birth Date", type: "datepicker", slot: 'additional' },                        
    dl_number: { label: "DL Number", type: "text", slot: 'additional' },
  };
  
  export const personForm = {
    id: "",
    given_name: "",
    middle_name: "",
    family_name: "",
    email: "",
    phone_mobile: "",
    phone_number: "",
    phone_other: "",
    phone_home: "",
    fax_number: "",
    addressHome: {
      fields: {
        street_address: "",
        locality: "",
        region: "",
        postal_code: "",
        country: "",
      }
    },    
    addressOther: {
      fields: {
        street_address: "",
        locality: "",
        region: "",
        postal_code: "",
        country: "",
      }
    },   
    ssn: "",                
    dob: null,
    dl_number: ""
  };
  
  export const personValidations =  {
    id: {},
    given_name: {required, minLength: minLength(3)},
    middle_name: {},
    family_name: {required, minLength: minLength(3)},
    email: {required, minLength: minLength(3)},
    phone_mobile: {},
    phone_number: {},
    phone_other: {},
    phone_home: {},
    fax_number: {},
    addressHome: {
      fields: {
        street_address: {},
        locality: {},
        region: {},
        postal_code: {},
        country: {},
      }
    },
    addressOther: {
      fields: {
        street_address: {},
        locality: {},
        region: {},
        postal_code: {},
        country: {},
      }
    },     
    ssn: {},     
    dob: {},
    dl_number: {}
  };

  export default {
    name: "person",
    mixins: [Record],
    computed: {
      personCompanyPersonId: function () { return { match: { personCompanyPersonId: this.$route.params.id } }; },
      personAccountPersonId: function () { return { "match": {"personAccountPersonId": this.$route.params.id }}; },
      relateCompanyPersonFilter: function () {
        let result = null;
        if (this.recordData && this.recordData.companys && this.recordData.companys.items) {
          let companys = this.recordData.companys.items;
          let filters = [];
          companys.forEach(item => {
            filters.push({"match": {"id": item.company.id}});
          });
          if (filters.length) {
            result = {"must_not": filters};
          }
        }

        return result;
      },
      relateAccountPersonFilter: function () {
        let result = null;
        if (this.recordData && this.recordData.accounts && this.recordData.accounts.items) {
          let accounts = this.recordData.accounts.items;
          let filters = [];
          accounts.forEach(item => {
            filters.push({"match": {"id": item.account.id}});
          });
          if (filters.length) {
            result = {"must_not": filters};
          }
        }
        return result;
      },
      casePersonFilter: function () { return { match_phrase: { casePersonId: this.$route.params.id } } },
    },
    data() {
      return {
        homeCountry: "",
        otherCountry: "",
        formConfig: {
          hasUpdatedBy: true,
          updatedByFieldName: 'personUpdatedById',
          responseFieldName: 'getPerson',
          actions: {
            save: 'createPerson',
            view: 'editPerson',
            edit: 'editPerson',
            new: 'newPerson',
            update: 'updatePerson',
            delete: 'deletePerson',
          },
          slots: {
            basic: {label: 'Basic Information', icon: 'work', layout: {"x":0,"y":0,"w":12,"h":18,"i":"0"}},
            contact: {label: 'Contact Information', icon: 'work', layout: {"x":0,"y":12,"w":12,"h":18,"i":"1"}},
            additional: {label: 'Additional Information', icon: 'work', layout: {"x":0,"y":24,"w":12,"h":18,"i":"2"}},
          },
          listPath: "/people",
          headerIcon: 'person',
          objectName: 'Person',
          objectNamePlural: 'People',
          editMode: false,
          pageMode: 'new', // can be one of ['new', 'view' 'edit']
          fields: _.cloneDeep(personFields),
          editTitleField: 'name'
        },
        form: _.cloneDeep(personForm),
        regionOptions: [],
        countryOptions: [],
        companysList: {
          showRelatedDialog: false,
          itemActions: [
            {
              class: "md-just-icon md-warning md-simple",
              icon: "description",
              click: "handleEdit"
            },
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete"
            }
          ],
          editPath: "companies",
          pageTitle: "Companies",
          pageIcon: "store",
          listQueryId: "searchPersonCompanys",
          responseFieldName: "searchPersonCompanys",
          deleteQueryId: "deletePersonCompany",
          deleteQueryIdField: "relateRecordId",
          deleteMessageTitle: "Are you sure you want to remove {objectName} from this Person?",
          deleteMessageText: "",
          columns: {
            'esData.company.name': { label: "Name", sortable: false, esNested: true },
            'esData.company.phone': { label: "Phone", sortable: false, esNested: true },
            'esData.company.phoneExt': { label: "Phone Ext", sortable: false, esNested: true },
          },
          pagination: {
            perPage: 25,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
            total: 0
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            keyword: false,
            perPage: 25,
          },
          currentSort: "createdAt",
          currentSortOrder: "desc",
          tableData: [],
          searchedData: [],
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchPersonCompanys && data.searchPersonCompanys.items.length) {
              this.$c.log('formatResponse data', data.searchPersonCompanys.items);
              data.searchPersonCompanys.items.forEach((item) => {
                /** Store the PersonCompany.id in the company as relateRecordId */
                item.relateRecordId = item.id;                
                // replace id with company id
                item.id = item.company.id;

                result.push(item);
              })
            }
            return result;
          },
        },
        relateCompanysList: {
          hideListHeader: true,
          skipCardLayout: true,
          editPath: "companies",
          pageTitle: "Search for Company",
          pageIcon: "store",
          listQueryId: "searchCompanys",
          createMutationId: "createPersonCompany",
          deleteQueryId: "deletePersonCompany",
          itemActions: [
            {
              class: "md-just-icon md-simple md-warning",
              classAdded: "item.added? 'check_circle' : 'md-warning'",
              icon: "post_add",
              iconAdded: "check_circle",
              click: "handleAdd"
            }
          ],
          columns: {
            name: { label: "Name", sortable: true },
            createdAt: { label: "Created", sortable: true },
            phone: { label: "Phone", sortable: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            this.$c.log(data);
            let result = [];
            let responseKey = 'searchCompanys';
            if (data && data[responseKey] !== 'undefined') {
              result = data[responseKey].items;
            }
            return result;
          },
        },
        accountsList: {
          refreshData: false,
          showRelatedDialog: false,
          itemActions: [
            {
              class: "md-just-icon md-warning md-simple",
              icon: "description",
              click: "handleEdit"
            },
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete"
            }
          ],
          editPath: "accounts",
          pageTitle: "Accounts",
          pageIcon: "work",
          listQueryId: "searchPersonAccounts",
          deleteQueryId: "deletePersonAccount",
          deleteQueryIdField: "relateRecordId",
          deleteMessageTitle: "Are you sure you want to remove {objectName} from this Person?",
          deleteMessageText: "",
          columns: {
            'esData.account.name': { label: "Name", sortable: false, esNested: true, },
            'esData.account.addressPhysical': { label: "Address", sortable: false, esNested: true, isAddress: true, },
            'esData.account.phoneBusiness': { label: "Phone", sortable: false, esNested: true, },
            'esData.account.createdAt': { label: "Created", sortable: false, esNested: true, },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchPersonAccounts && data.searchPersonAccounts.items.length) {
              this.$c.log('formatResponse data', data.items);
              data.searchPersonAccounts.items.forEach((item) => {
                // /** Store the PersonAccount.id in the account as relateRecordId */
                // item.account.relateRecordId = item.id;
                // /** We only need the account portion of the PersonAccount record */
                // item = item.account;
                // /** Format addresses for display */
                // ['addressPhysical', 'addressMailing'].forEach(addressName => {
                //   let itemAddress = item[addressName];
                //   if (typeof itemAddress !== 'undefined' && itemAddress) {
                //     item[addressName] = this.$format.JsonAddressToString(itemAddress);
                //   }
                // });

                // /**
                //  * ATLAS-935 Company > Account tab: DB value is showing in Address column for State and Country
                //  * 
                //  * Remove Country code and underscores from Address fields
                //  */
                // if(item.addressPhysical) {
                //   item.addressPhysical = item.addressPhysical.replace(/US_|CA_|_/g, ' ').trim();
                // }
                // if(item.addressMailing) {
                //   item.addressMailing = item.addressMailing.replace(/US_|CA_|_/g, ' ').trim();
                // }
                
                /** Store the PersonAccount.id in the account as relateRecordId */
                item.relateRecordId = item.id;
                
                // replace id with account id
                item.id = item.account.id;

                result.push(item);
              })
            }
            return result;
          },
        },

        relateAccountsList: {
          hideListHeader: true,
          skipCardLayout: true,
          editPath: "accounts",
          pageTitle: "Search for Account",
          pageIcon: "work",
          listQueryId: "searchAccountCustoms",
          responseFieldName: "searchAccounts",
          createMutationId: "createPersonAccount",
          deleteQueryId: "deletePersonAccount",
          itemActions: [
            {
              class: "md-just-icon md-simple md-warning",
              classAdded: "item.added? 'check_circle' : 'md-warning'",
              icon: "post_add",
              iconAdded: "check_circle",
              click: "handleAddRole"
            }
          ],
          columns: {
            name: { label: "Name", sortable: true },
            companyName: { label: "Company", sortable: false },
            addressPhysical: { label: "Address", sortable: false },
            createdAt: { label: "Created", sortable: true },
          },
          roleRecord: {
            Owner_1: "Owner 1", 
            Owner_2: "Owner 2",
            Owner_3: "Owner 3",
            Owner_4: "Owner 4",
            Controlling_Position: "Controlling Position",
            Vendor_1: "Vendor 1",
            Vendor_2: "Vendor 2",
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            this.$c.log(data);
            let result = [];
            let responseKey = 'searchAccounts';
            if (data && data[responseKey] !== 'undefined') {
              let items = data[responseKey].items;
              items.forEach((item) => {
                /** Surface the Company name if it has one */
                item.companyName = (item.company && item.company.name)? item.company.name : '';
                /** Format the addresses for display */
                ['addressPhysical', 'addressMailing'].forEach(addressName => {
                  let itemAddress = item[addressName];
                  if (typeof itemAddress !== 'undefined' && itemAddress) {
                    item[addressName] = this.$format.JsonAddressToString(itemAddress);
                  }
                });

                /**
                 * ATLAS-935 Company > Account tab: DB value is showing in Address column for State and Country
                 * 
                 * Remove Country code and underscores from Address fields
                 */
                if(item.addressPhysical) {
                  item.addressPhysical = item.addressPhysical.replace(/US_|CA_|_/g, ' ').trim();
                }
                if(item.addressMailing) {
                  item.addressMailing = item.addressMailing.replace(/US_|CA_|_/g, ' ').trim();
                }

                result.push(item);
              })
            }
            return result;
          },
        },

        casesList: {
          showRelatedDialog: false,
          hideNewRecordButton: true,
          editPath: "cases",
          pageTitle: "Cases",
          pageIcon: "store",
          listQueryId: "searchCases",
          deleteMessageTitle: "Are you sure you want to remove {objectName} from this Person?",
          deleteMessageText: "",
          deleteMessageNameFields: ['subject'],
          disassociateRecord: { updateQueryId: "updateCase", updateFieldId: "casePersonId" },
          itemActions: [
            {
              class: "md-just-icon md-warning md-simple",
              icon: "description",
              click: "handleEdit"
            },
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete"
            }
          ],
          columns: {
            createdAt: { label: "Created", sortable: true},
            subject: { label: "Subject", sortable: true },
            quickNote: { label: "Quick Note", sortable: true },
            priority: { label: "Priority", sortable: true },
            closedDate: { label: "Closed", sortable: true},
            status: { label: "Status", sortable: true },
            user: { label: "Assignee", sortable: false, display: true, nested: ["given_name", "family_name"]  },
            team: { label: "Team", sortable: false, searchable: true, display: true, nested: ["name"] },
            template: { label: "Type", sortable: false, searchable: true, display: true, nested: ["subject"] }
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },          
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchCases && data.searchCases.items && data.searchCases.items.length) {
              this.$c.log('formatResponse data: ', data.searchCases.items);
              data.searchCases.items.forEach((item) => {
                //match person
                  item.quickNote = item.quickNote ? item.quickNote.substring(0, 30) : '';
                  result.push(item);
              });
            }

            //sort results with currentSort & currentSortOrder
            const items = result;
            if (items && items.length) {
              const sortedItmes = _.sortBy(items, this.casesList.currentSort);
              if ('desc' == this.casesList.currentSortOrder) {
                result = sortedItmes.reverse();
              } else {
                result = sortedItmes;
              }
            }
            return result;
          },
        },
        // relateCasesList: {
        //   isOfflineSearchEnabled: true,
        //   searchRecordsInput: false, //disable search input
        //   hideListHeader: true,
        //   skipCardLayout: true,
        //   editPath: "cases",
        //   pageTitle: "Search for Case",
        //   pageIcon: "store",
        //   listQueryId: "searchCases",
        //   createMutationId: "updateCase",
        //   itemActions: [
        //     {
        //       class: "md-just-icon md-simple md-warning",
        //       classAdded: "item.added? 'check_circle' : 'md-warning'",
        //       icon: "post_add",
        //       iconAdded: "check_circle",
        //       click: "handleAdd"
        //     }
        //   ],
        //   columns: {
        //     subject: { label: "Subject", sortable: true },
        //     status: { label: "Status", sortable: true },
        //     //priority: { label: "Priority", sortable: true },
        //     createdAt: { label: "Created", sortable: true },
        //   },
        //   perPageOptions: [5, 10, 20, 25, 50],
        //   defaults: {
        //     sort: 'createdAt',
        //     sortDir: 'desc',
        //     perPage: 10,
        //   },
        //   fuseSearch: null,
        //   formatResponse: (data) => {
        //     let result = [];
        //     if (data && data.searchCases && data.searchCases.items && data.searchCases.items.length) {
        //       this.$c.log('formatResponse data: ', data.searchCases.items);
        //       data.searchCases.items.forEach((item) => {
        //         //get cases without person assigned
        //         if (!item.person || item.person === null) {
        //           result.push(item);
        //         }
        //       });
        //     }
        //     return result;
        //   },
        // },
        
        subscriptions: {
          'onCreatePersonAccount': {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onCreatePersonAccount');
              let eventRecord = eventData.value.data.onCreatePersonAccount;
              /** Filter out records that do not apply to the Person we are looking at */
              if (this.recordData.id === eventRecord.person.id) {
                this.$c.log('SUBSCRIPTION MATCH!: onCreatePersonAccount');



                //Force a refresh on the ConfigForm component
                window.setTimeout(() => {
                  this.$refs.accountsListRef.refresh();
                  this.formConfig.refreshRecordData = true;
                }, 2000);
              }
            }
          },
          'onDeletePersonAccount': {
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onDeletePersonAccount');
              let eventRecord = eventData.value.data.onDeletePersonAccount;
              if (this.recordData.id === eventRecord.person.id) {
                this.$c.log('SUBSCRIPTION MATCH: onDeletePersonAccount');
                //Force a refresh on the ConfigForm component
                window.setTimeout(() => {
                  this.$refs.accountsListRef.refresh();
                  this.formConfig.refreshRecordData = true; 
                }, 2000);
              }
            }
          },
          'onCreatePersonCompany': {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onCreatePersonCompany');
              let eventRecord = eventData.value.data.onCreatePersonCompany;
              /** Filter out records that do not apply to the Person we are looking at */
              if (this.recordData.id === eventRecord.person.id) {
                this.$c.log('SUBSCRIPTION MATCH: onCreatePersonCompany');
                window.setTimeout(() => {
                  this.$refs.companysListRef.refresh();
                  this.formConfig.refreshRecordData = true;       
                }, 2000);                                       
              }
            }
          },
          'onDeletePersonCompany': {
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onDeletePersonCompany');
              let eventRecord = eventData.value.data.onDeletePersonCompany;
              if (this.recordData.id === eventRecord.person.id) {
                this.$c.log('SUBSCRIPTION MATCH: onDeletePersonCompany');
                window.setTimeout(() => {
                  this.$refs.companysListRef.refresh();
                  this.formConfig.refreshRecordData = true;
                }, 2000);                
              }
            }
          },
        },
      }
    },
    validations() {
      return {
        form: _.cloneDeep(personValidations),
        // formConfig: {
        //   fields: {
        //     id: {value: {}},
        //     name: {value: {required, minLength: minLength(3)}},
        //     phone: {value: {required, minLength: minLength(3)}},
        //     phoneExt: {value: {required, numeric, minLength: minLength(3)}},
        //     status: {value: {}},
        //   }
        // }
      }
    },
    methods: {
      updateFormAfter(data) {
        if (typeof data === 'undefined') return;

        //State and Country dropdown options
        this.getRegionEnumOptions(data);
        this.getCountryEnumOptions(data);
      },
      /**
       * Methods for State & Country dropdown
       */
      getRegionEnumOptions(data) {
        this.regionOptions = [];

        if (data.listStatesEnum && data.listStatesEnum.enumValues) {
          data.listStatesEnum.enumValues.map(_value => {
            let _name = _value.name.replace(/US_|CA_/g, '');
            this.regionOptions.push({
              id: _value.name,
              name: _name.replace(/\_/g, ' ')
            });
          });
          
          this.formConfig.fields.addressHome.fields.region.options = this.regionOptions;
          this.formConfig.fields.addressOther.fields.region.options = this.regionOptions;
        }
      },
      getCountryEnumOptions(data) {
        this.countryOptions = [];

        if (data.listCountriesEnum && data.listCountriesEnum.enumValues) {
          data.listCountriesEnum.enumValues.map(_value => {
            let _name = _value.name.replace(/US_|CA_/g, '');
            this.countryOptions.push({
              id: _value.name.replace(/_United_States|_Canada/g,''),
              name: _name.replace(/\_/g, ' ')
            });
          });
          
          this.formConfig.fields.addressHome.fields.country.options = this.countryOptions;
          this.formConfig.fields.addressOther.fields.country.options = this.countryOptions;
        }
      }
    },    
    watch: {
      /**            
       * Following four watchers will set the Country based on State selection &
       * load specific State list based on Country selection
       */
      "$v.form.addressHome.fields.region.$model": {
        immediate: true,
        handler: function() {
          if (this.form.addressHome.fields.region) {
            let countryCode = this.form.addressHome.fields.region.split("_");
            this.form.addressHome.fields.country = countryCode[0];
          }
        }                       
      },
      "$v.form.addressHome.fields.country.$model": {
        immediate: true,
        handler: function() {
          if (this.form.addressHome.fields.country) {
            if (this.homeCountry && this.homeCountry != this.form.addressHome.fields.country) {
              this.form.addressHome.fields.region = "";
            }

            let newRegionOptions = [];
            this.regionOptions.forEach(item => {
              if(item.id.includes(this.form.addressHome.fields.country + "_")) {
                newRegionOptions.push(item);
              }
            });

            this.homeCountry = this.form.addressHome.fields.country;
            this.formConfig.fields.addressHome.fields.region.options = newRegionOptions;
          }
        }                       
      },
      "$v.form.addressOther.fields.region.$model": {
        immediate: true,
        handler: function() {
          if (this.form.addressOther.fields.region) {
            let countryCode = this.form.addressOther.fields.region.split("_");
            this.form.addressOther.fields.country = countryCode[0];
          }
        }                       
      },
      "$v.form.addressOther.fields.country.$model": {
        immediate: true,
        handler: function() {
          if (this.form.addressOther.fields.country) {
            if (this.otherCountry && this.otherCountry != this.form.addressOther.fields.country) {
              this.form.addressOther.fields.region = "";
            }

            let newRegionOpts = [];
            this.regionOptions.forEach(item => {
              if(item.id.includes(this.form.addressOther.fields.country + "_")) {
                newRegionOpts.push(item);
              }
            });

            this.otherCountry = this.form.addressOther.fields.country;
            this.formConfig.fields.addressOther.fields.region.options = newRegionOpts;
          }
        }
      }
    }    
  }
</script>

<style lang="scss">

  .md-tabs .md-tabs-navigation {
    padding-left: 15px;
    color: black;
    display: none;

    .md-tab-nav-button.md-button {
      color: black !important;

      &.active {
        color: black !important;
        border-bottom: 2px solid black;
      }
    }
  }

  .md-content .md-tabs-container .md-tab > .md-layout-item {
    padding-left: 0;
    padding-right: 0;
  }

#tab-person-cases .md-table-row.textRed {
  color: black !important;
}

</style>
